module.exports = __webpack_public_path__ + "media/applicants/check-unfill_2x-6675c05a.png";